import en from './data.en'
import cn from './data.cn'

export default {
  en,
  cn,
}